module.exports = __webpack_public_path__ + "img/bgtop.7992b0f3.jpg";